import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';

import './ContactCard.scss';
import { PLACEHOLDER } from 'other/constants';
import { Placeholder } from 'components/common/banners/Placeholder';
import { PROVIDER_IMAGE_URL } from 'other/config';
import { EProviderMediaObjectType, TPerson } from 'types';

type Props = { item: TPerson };

function getPhone(phone: string): string {
  if (!phone) return '';
  return phone.startsWith('+') ? phone : '+' + phone;
}

const ContactCard = ({ item }: Props): ReactElement => {
  if (!item) return null;

  const { email, firstName, lastName, mobile, photo, position, telephone } =
    item;

  const _phone = getPhone(telephone);
  const _mobile = getPhone(mobile);

  const name = `${firstName} ${lastName}`;
  const src = photo && `${PROVIDER_IMAGE_URL}/${photo.path}`;

  if (!photo && !firstName)
    return (
      <div className="ContactCard">
        <Placeholder placeholder={PLACEHOLDER.CONTACT_CARD} />
      </div>
    );

  return (
    <div className="ContactCard">
      <figure className="ContactCard__photo">
        <Placeholder
          alt={name}
          draggable={false}
          placeholder={PLACEHOLDER.CONTACT}
          src={src}
        />
      </figure>

      <ul className="ContactCard__info app-body-2">
        <li className="ContactCard__name">
          <div className="app-subtitle-1">{name}</div>
        </li>
        <li className="ContactCard__position">{position}</li>
        <li>
          <a href={`tel:${_phone}`}>{_phone}</a>
        </li>
        {mobile && (
          <li>
            <a href={`tel:${_mobile}`}>{_mobile}</a>
          </li>
        )}
        <li>
          <a href={`mailto:${email}`}>{email}</a>
        </li>
      </ul>
    </div>
  );
};

ContactCard.label = EProviderMediaObjectType.CONTACT;
ContactCard.propTypes = {
  item: PropTypes.object
};

export default ContactCard as any;
